/**
 * Keeps preview-mode UI in sync with the configured reopen timestamp.
 * Helps when HTML is CDN-cached past the Liquid "now" evaluation.
 */
(function () {
  const config = window.themeVariables && window.themeVariables.previewMode;
  if (!config || !config.enabled) return;

  const openTs = Number(config.opensAt || 0);

  function isClosed() {
    if (!config.enabled) return false;
    if (!openTs) return true;
    return Math.floor(Date.now() / 1000) < openTs;
  }

  function syncRoots() {
    const closed = isClosed();
    document.querySelectorAll('[data-preview-root]').forEach((root) => {
      const closedEl = root.querySelector('[data-preview-closed]');
      const openEl = root.querySelector('[data-preview-open]');
      if (closedEl) closedEl.hidden = !closed;
      if (openEl) openEl.hidden = closed;
      root.dataset.previewActive = closed ? 'true' : 'false';
    });

    document.querySelectorAll('[data-preview-hide-when-active]').forEach((el) => {
      el.hidden = closed;
    });
  }

  syncRoots();

  if (openTs && isClosed()) {
    const msUntilOpen = openTs * 1000 - Date.now();
    if (msUntilOpen > 0 && msUntilOpen < 2147483647) {
      window.setTimeout(() => {
        syncRoots();
        // Soft refresh so cart/section HTML also picks up open state.
        window.location.reload();
      }, msUntilOpen + 250);
    }
  }

  document.addEventListener('cart:refresh', syncRoots);
})();
